var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168210",
    "data-name": "Group 168210",
    transform: "translate(-651.367 -94.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167752",
    "data-name": "Path 167752",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(651.867 95)",
    fill: "none",
    stroke: "#649aee",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-edit-2",
    "data-name": "Icon feather-edit-2",
    d: "M11.136,1.757a2.05,2.05,0,0,1,1.449,3.5L5.358,12.483a.535.535,0,0,1-.238.138l-2.944.8a.535.535,0,0,1-.657-.657l.8-2.944a.535.535,0,0,1,.138-.238l7.23-7.224a2.036,2.036,0,0,1,1.449-.6ZM4.7,11.626,11.828,4.5a.979.979,0,1,0-1.384-1.384L3.317,10.241l-.519,1.9Z",
    transform: "translate(659.524 102.399)",
    fill: "#5f97ed"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/edit-circle.fd03aa3e592486577f0b3787d9f79d57.svg";
export { ForwardRef as ReactComponent };